export const OnboardingActionTypes = {
  ONBOARDING_REGISTER_REQUEST: 'ONBOARDING_REGISTER_REQUEST',
  ONBOARDING_REGISTER_SUCCESS: 'ONBOARDING_REGISTER_SUCCESS',
  ONBOARDING_REGISTER_FAILURE: 'ONBOARDING_REGISTER_FAILURE',

  ONBOARDING_UPDATE_REQUEST: 'ONBOARDING_UPDATE_REQUEST',
  ONBOARDING_UPDATE_SUCCESS: 'ONBOARDING_UPDATE_SUCCESS',
  ONBOARDING_UPDATE_FAILURE: 'ONBOARDING_UPDATE_FAILURE',

  WIZARD_REGISTER_REQUEST: 'WIZARD_REGISTER_REQUEST',
  SET_WIZARD_REGISTER: 'SET_WIZARD_REGISTER',
  WIZARD_REGISTER_SUCCESS: 'WIZARD_REGISTER_SUCCESS',
  WIZARD_REGISTER_FAILURE: 'WIZARD_REGISTER_FAILURE',

  WIZARD_UPDATE_REQUEST: 'WIZARD_UPDATE_REQUEST',
  WIZARD_UPDATE_SUCCESS: 'WIZARD_UPDATE_SUCCESS',
  WIZARD_UPDATE_FAILURE: 'WIZARD_UPDATE_FAILURE',

  RESET_ONBOARDING: 'RESET_ONBOARDING',

  // AI SITEBUILDER
  BUSINESS_LIST_BUILDER_REQUEST: 'BUSINESS_LIST_BUILDER_REQUEST',
  BUSINESS_LIST_BUILDER_SET: 'BUSINESS_LIST_BUILDER_SET',
  BUSINESS_LIST_BUILDER_SUCCESS: 'BUSINESS_LIST_BUILDER_SUCCESS',
  BUSINESS_LIST_BUILDER_FAILURE: 'BUSINESS_LIST_BUILDER_FAILURE',

  REQUEST_SITEBUILDER_TEMPLATES: 'REQUEST_SITEBUILDER_TEMPLATES',
  SET_DEFAULT_SITEBUILDER_TEMPLATES: 'SET_DEFAULT_SITEBUILDER_TEMPLATES',
  SET_SITEBUILDER_TEMPLATES_SUCCESS: 'SET_SITEBUILDER_TEMPLATES_SUCCESS',
  SET_SITEBUILDER_TEMPLATES_FAILURE: 'SET_SITEBUILDER_TEMPLATES_FAILURE',
  SET_SITEBUILDER_TEMPLATES: 'SET_SITEBUILDER_TEMPLATES',
  SET_SITEBUILDER_TEMPLATES_LOADING: 'SET_SITEBUILDER_TEMPLATES_LOADING',
  RESET_SITEBUILDER_TEMPLATES_STATE: 'RESET_SITEBUILDER_TEMPLATES_STATE',
  REQUEST_SITEBUILDER_TEMPLATES_BY_TERM: 'REQUEST_SITEBUILDER_TEMPLATES_BY_TERM',
  RETURN_SITEBUILDER_TEMPLATES_TO_DEFAULT: 'RETURN_SITEBUILDER_TEMPLATES_TO_DEFAULT',


  REQUEST_SITEBUILDER_CATEGORIES: 'REQUEST_SITEBUILDER_CATEGORIES',
  SET_SITEBUILDER_CATEGORIES: 'SET_SITEBUILDER_CATEGORIES',
  SET_SITEBUILDER_CATEGORIES_LOADING: 'SET_SITEBUILDER_CATEGORIES_LOADING',
  SET_SITEBUILDER_CATEGORIES_SUCCESS: 'SET_SITEBUILDER_CATEGORIES_SUCCESS',
  SET_SITEBUILDER_CATEGORIES_FAILURE: 'SET_SITEBUILDER_CATEGORIES_FAILURE',

  REQUEST_SITEBUILDER_PROVISIONING: 'REQUEST_SITEBUILDER_PROVISIONING',
  SET_SITEBUILDER_PROVISIONING: 'SET_SITEBUILDER_PROVISIONING',
  SET_SITEBUILDER_PROVISIONING_FAILURE: 'SET_SITEBUILDER_PROVISIONING_FAILURE',
  RESET_SITEBUILDER_PROVISIONING: 'RESET_SITEBUILDER_PROVISIONING',

  REGISTER_CLM_EVENT: 'REGISTER_CLM_EVENT',
};
